var _path;
import * as React from "react";
function SvgHeartFill(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.347 22.765l12.705 11.862a2.854 2.854 0 003.896 0l12.705-11.862a10.519 10.519 0 003.347-7.7v-.407a10.05 10.05 0 00-17.156-7.109L20 8.393l-.844-.844A10.05 10.05 0 002 14.658v.408c0 2.918 1.21 5.71 3.347 7.699z"
  })));
}
export default SvgHeartFill;